import React from "react";
import AdminShell from "../components/AdminShell";
import GiftCodesPanel from "../components/GiftCodesPanel";
import ProInvitesPanel from "../components/AdminProInvitesPanel";

/**
 * AdminGiftCodes — admin tools for comping Pro.
 *   1. Pro invites: email someone a one-tap link → account + Pro in one
 *      step (zero authorization, "invited = instantly Pro").
 *   2. Gift codes: mint a code they redeem in Settings (good for DMs /
 *      printed cards / when you don't know their email).
 */
const AdminGiftCodes = () => (
  <AdminShell
    eyebrow="Generosity"
    title="Gifts & comps"
    subtitle="Send Pro by email with a one-tap link, or mint personal gift codes for founding members and the people who shape TruBeauté with you."
  >
    <ProInvitesPanel />
    <GiftCodesPanel />
  </AdminShell>
);

export default AdminGiftCodes;
